import "./style.css";

export function Circle() {
  return (
    <div id="base">
      <div className="circle_div">
        <img className="circle" src="./img/u16.svg" />
      </div>
    </div>
  );
}
